/**
 * Created by maofaming on 2017/4/28.
 */

import ContentConfig from '@/module/ContentConfig';

const COMMENT_TYPE = {
    NORMAL: '1',
    AUDIT: '2',
    HIDE: '3',
    CLOSE: '4'
};

const COMMENT_STATUS = {
    [COMMENT_TYPE.NORMAL]: '正常评论',
    [COMMENT_TYPE.AUDIT]: '必审评论',
    // [COMMENT_TYPE.HIDE]: '隐藏评论',
    [COMMENT_TYPE.CLOSE]: '关闭评论'
};

const CHANNEL_SOURCE = {
    USER: 1,
    NETWORK: 2,
    MANUAL: 3
};
const shortKey = {
    entry: ['shift-enter'],
    copy: ['shift-b'],
    quit: ['alt-q'],
    focus: ['alt-i'],
    view: ['alt-v'],
    one: ['1'],
    two: ['2'],
    third: ['3'],
    four: ['4'],
    audit: ['s'],
    cancel: ['d'],
    exit: ['e'],
    // add short-key for user-audit
    passPanel: ['s'],
    rejectPanel: ['d'],
    quitAudit: ['q'],
    sendAudit: ['f'],
    newSendAudit: ['spacebar'],
    assert: [' '],
    changeView: ['v'],
    miduQuit: ['r'],
    miduReset: ['z'],
    miduPass: ['s']
};
// 新添加初审列表

export default {
    qualityStatus: [
        {
            key: 2,
            name: '常规'
        },
        {
            key: 3,
            name: '高质量'
        }
    ],
    lifeStatus: [
        {
            key: 1,
            name: '无时效'
        },
        {
            key: 2,
            name: '有时效'
        }
    ],
    shortKey: shortKey,
    listStatus: [
        {
            key: 0,
            name: '加入黑名单'
        },
        {
            key: 1,
            name: '加入白名单'
        }
    ],
    userRoleStatus: {
        tagType: ['danger', 'success'],
        text: ['已加入黑名单', '已加入白名单']
    },
    commentType: ContentConfig.type,
    commentStatus: ContentConfig.status,
    CHANNEL_SOURCE: CHANNEL_SOURCE,
    defaultDetailData: {
        status: '', // 通过: 1  驳回: 2
        contentId: '', // id
        safetyGroup: '',
        categoryName: '', // 分类名
        coverImage: [], // 封面图
        detail: '', // 类容
        origin: '', // 是否原创
        submitTime: '', // 投稿时间
        platformName: '', // 平台来源
        memberName: '', // 作者名称
        memberTypeName: '', // 用户类型名称
        machineAuditResult: {}, // 机审结果
        memberBlackWhite: '', // "黑"或"白"名单
        memberBlackWhiteNote: '', // 备注
        title: '' // 标题
    },
    defaultAudit: {
        contentId: '',
        status: 1,
        reason: '', // 驳回理由
        // is_recommend: 1,
        cpmReasons: [], // 通过后建议优化项
        punishGrade: '', // 驳回理由等级
        // discard: 0, // 是否废弃内容 0正常，1废弃
        rejectReasonIds: '', // 驳回原因
        closeComment: '2', // 1：关闭 2：不关闭
        hitSpecial: '2', // 1：必审2：不必须
        hideComment: '2', // 1：隐藏2：不隐藏
        queueType: '' // 查询队列类型
    },
    auditStatus: [
        {
            key: 1,
            name: '通过',
            short: shortKey.passPanel
        },
        {
            key: 2,
            name: '驳回',
            short: shortKey.rejectPanel
        }
    ]
};
